import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import classes from './Drafts.module.css';
import { DeletePostDialogue } from 'components/Dialogues';
import Spinner from 'components/UI/Spinner/Spinner';
import {
  formatDateForDisplay,
  formatPostItemDateRange,
  formatTimeRangeForPostsTableDisplay,
  getRgbFromColorName,
  truncateText,
  updateObject,
  utcToLocalDateTime,
} from 'shared/utility';
import * as actions from 'store/actions';

class Drafts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortColumns: {
        DateStart: {
          name: 'Date',
          direction: 'desc',
        },
        CreatedBy: {
          name: 'Gift',
          direction: 'desc',
        },
        DatePostUpdated: {
          name: 'Date Modified',
          direction: 'desc',
        },
        Title: {
          name: 'Title',
          direction: 'desc',
        },
      },
      postsPerQuery: 50,
      currentPageNumber: 1,
      selectedSortColumn: 'DateStart',
      activeRowId: null,
      showSortDropdown: false,
      showDeletePostConfirmation: false,
      postDeleteId: null,
    };
  }

  componentDidMount() {
    if (this.props.postingAs.UserId) this.handleDraftsFetch(1);
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.postingAs.UserId && !prevProps.postingAs.UserId) ||
      (this.props.deleted && !prevProps.deleted) ||
      (this.props.submitted && !prevProps.submitted)
    )
      this.handleDraftsFetch(1);
  }

  handleDraftsFetch = (pageNumber, sortBy) => {
    const userId = this.props.isManagedUser ? this.props.postingAs.UserId : null;
    let sortPostsBy =
      sortBy ||
      (this.state.sortColumns[this.state.selectedSortColumn].sortOrder === 'asc'
        ? `${this.state.selectedSortColumn}_REV`
        : this.state.selectedSortColumn);
    if (sortPostsBy === 'CreatedBy') sortPostsBy = 'GIFTEDTOME';
    this.props.onFetchDrafts(userId, this.props.isManagedUser, sortPostsBy, pageNumber, this.state.postsPerQuery, null);
    this.setState({ currentPageNumber: pageNumber });
  };

  fetchMorePosts = () => {
    if (!this.props.loading && this.props.totalDrafts > this.state.postsPerQuery * this.state.currentPageNumber) {
      this.handleDraftsFetch(this.state.currentPageNumber + 1);
    }
  };

  handleSort = (sortProperty, order) => {
    const updatedSortColumns = this.updatedSortColumnsOrder(sortProperty, order);
    const sortPostsBy = order === 'asc' ? `${sortProperty}_REV` : sortProperty;
    this.setState({ selectedSortColumn: sortProperty, sortColumns: updatedSortColumns, currentPageNumber: 1 });
    this.handleDraftsFetch(1, sortPostsBy);
    this.toggleSortDropdown();
  };

  updatedSortColumnsOrder = (sortProperty, order) => {
    const updatedSortColumns = updateObject(this.state.sortColumns, {
      [sortProperty]: {
        name: this.state.sortColumns[sortProperty].name,
        sortOrder: order,
      },
    });
    return updatedSortColumns;
  };

  toggleSortDropdown = () => {
    this.setState({ showSortDropdown: !this.state.showSortDropdown });
  };

  duplicatePost = (postId, title) => {
    const duplicatePostRegexp = /(\s+)(—)(\s+)(\d+$)/;
    const baseTitle = title.replace(duplicatePostRegexp, '');
    const copyNumber = this.props.drafts.filter((draft) => draft.Post.Name.includes(baseTitle)).length;
    this.props.onDuplicatePost(postId, true, copyNumber);
  };

  edit = (draftId) => {
    this.props.onToggleGiftsDraftsModal();
    this.props.onInitPostForm(draftId, true, false, null, this.props.postingAs.UserId, this.props.isManagedUser);
  };

  renderPostDeletionDialogue = (draftId) => {
    this.setState({ showDeletePostConfirmation: true, postDeleteId: draftId });
  };

  cancelPostDeletion = () => {
    this.setState({ showDeletePostConfirmation: false, postDeleteId: null });
  };

  handlePostDelete = () => {
    this.props.onDeletePost(this.state.postDeleteId);
    this.setState({ showDeletePostConfirmation: false, postDeleteId: null });
  };

  render = () => {
    const modalHeight = document.getElementById('modal-container') ? document.getElementById('modal-container').clientHeight : 500;
    let postsList = <Spinner />;
    // const userLogsList = this.props.postingAs.Logs ? this.props.postingAs.Logs.map((log) => ({ Name: log.Name, Id: log.Id })) : null;
    let dialogue = null;

    if (this.state.showDeletePostConfirmation) {
      dialogue = (
        <DeletePostDialogue
          className="Drafts"
          subject="DELETE DRAFT"
          message="Are you sure you want to DELETE this draft? If so, all this content will be permanently deleted from riza."
          clicked={this.handlePostDelete}
          cancelled={this.cancelPostDeletion}
        />
      );
    }
    if (this.props.drafts.length > 0) {
      postsList = (
        <div id="posts-list" className={classes.DraftsAndGifts} style={{ height: `${modalHeight - 123}px` }}>
          <InfiniteScroll
            scrollableTarget="posts-list"
            dataLength={this.props.drafts.length}
            next={this.fetchMorePosts}
            endMessage={this.props.totalDrafts > this.state.postsPerQuery ? '' : ''}
            hasMore={
              this.props.loading && this.props.currentPageNumber === 1 ? true : this.props.drafts.length < this.props.postingAs.GiftsDraftsCount
            }
          >
            {this.props.drafts.map((draft) => {
              const postDateRange = `${formatPostItemDateRange(
                draft.Post.DateStartCalc,
                draft.Post.DateEndCalc,
              )}\n${formatTimeRangeForPostsTableDisplay(draft.Post.TimeStartCalc, draft.Post.TimeEndCalc, draft.Post.Ongoing)}`;

              const dateModified =
                draft.Post.DatePostUpdated !== undefined ? formatDateForDisplay(utcToLocalDateTime(draft.Post.DatePostUpdated).toString()) : '';

              return (
                <div
                  key={draft.Post.PostId}
                  className={this.state.activeRowId === draft.Post.PostId ? [classes.ListItem, classes.Active].join(' ') : classes.ListItem}
                  onMouseEnter={() => this.setState({ activeRowId: draft.Post.PostId })}
                  onMouseLeave={() => this.setState({ activeRowId: null })}
                  onClick={() => this.edit(draft.Post.PostId)}
                >
                  <div className={classes.ImageColumn}>
                    <div className={classes.ImageContainer}>
                      {draft.Files.Files && draft.Files.Files.length > 0 ? (
                        <img
                          className={classes.ThumbnailImage}
                          // style={{ border: false ? '4px solid #23b7e5' : 'transparent' }}
                          style={{ border: 'transparent' }}
                          src={_get(draft, 'Files.Files.0.ImageURL', _get(draft, 'Files.Files.0.ThumbURL'))}
                          alt={draft.Post.Name}
                        />
                      ) : (
                        <div className={classes.DefaultImage} />
                      )}
                      {draft.FileCount > 1 ? (
                        <div className={classes.FileCount}>
                          <span>{draft.Files.Files.length}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={classes.DraftDetails}>
                    {draft.Post.Name ? (
                      <h2 className={classes.PostTitle}>{truncateText(draft.Post.Name, 71)}</h2>
                    ) : (
                      <h2 className={classes.NoPostTitle}>(No Title)</h2>
                    )}
                    {draft.Post.DateStartCalc ? (
                      <p className={classes.PostDateStartRange}>{postDateRange}</p>
                    ) : (
                      <p className={classes.NoDateStart}>(no date)</p>
                    )}
                    <p className={classes.DateModified}>Date Modified: {dateModified}</p>
                    {this.props.postingAs.UserId !== draft.Post.CreatedByUserId ? (
                      <div
                        style={{ color: draft.CreatedBy ? getRgbFromColorName(draft.CreatedBy.Color) : 'rgb(108 162 183)' }}
                        className={classes.GiftedDetails}
                      >
                        {draft.CreatedBy ? `Gifted to me by ${draft.CreatedBy.FirstName} ${draft.CreatedBy.LastName}` : ''}
                      </div>
                    ) : null}
                  </div>
                  <div className={classes.DraftActions}>
                    <FontAwesomeIcon
                      icon="pencil-alt"
                      onClick={(event) => {
                        event.stopPropagation();
                        this.edit(draft.Post.PostId);
                      }}
                      className={classes.EditIcon}
                    />
                    <FontAwesomeIcon
                      icon="copy"
                      onClick={(event) => {
                        event.stopPropagation();
                        this.duplicatePost(draft.Post.PostId, draft.Post.Name);
                      }}
                      className={classes.CopyIcon}
                    />
                    <FontAwesomeIcon
                      icon="trash"
                      onClick={(event) => {
                        event.stopPropagation();
                        this.renderPostDeletionDialogue(draft.Post.PostId);
                      }}
                      className={classes.DeleteIcon}
                    />
                  </div>
                </div>
              );
            })}
          </InfiniteScroll>
        </div>
      );
    }
    return (
      <div>
        {dialogue}
        <div className={classes.Container} style={{ height: `${modalHeight - 30}px` }}>
          <div className={classes.Header}>
            {this.props.showPostForm === true ? (
              <FontAwesomeIcon icon="chevron-left" onClick={this.props.close} className={classes.CloseIcon} />
            ) : (
              <FontAwesomeIcon className={classes.CloseIcon} onClick={this.props.close} icon="times" />
            )}
            <h1>{this.props.postingAs.FirstName ? `${this.props.postingAs.FirstName}'s ` : null} Drafts & Gifts</h1>
          </div>
          <div className={classes.SortByContainer}>
            <div className={classes.Label} onClick={this.toggleSortDropdown}>
              <span>Sort By {this.state.sortColumns[this.state.selectedSortColumn].name}</span>
              <FontAwesomeIcon icon="chevron-down" className={classes.SortIcon} />
            </div>
            <div className={this.state.showSortDropdown ? [classes.SortOptions, classes.Shown].join(' ') : classes.SortOptions}>
              {Object.keys(this.state.sortColumns).map((sortColumnKey) => (
                <div className={classes.SortOption} key={sortColumnKey} onClick={() => this.handleSort(sortColumnKey, 'desc')}>
                  {this.state.sortColumns[sortColumnKey].name}
                </div>
              ))}
            </div>
          </div>
          {postsList}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    drafts: state.logs.Drafts.Drafts,
    totalDrafts: state.logs.Drafts.TotalDraftsCount,
    deleted: state.post.deleted,
    submitted: state.post.submitted,
    error: state.logs.error,
    loading: state.logs.loading,
    postingAs: state.user.postingAs,
    signedInAs: state.user.signedInAs,
    isManagedUser: state.user.postingAs.UserId !== state.user.signedInAs.UserId,
    showPostForm: state.post.showPostForm,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchDrafts: (UserId, isManagedUser, SortBy, Page, PageSize, PageFilter) =>
      dispatch(actions.fetchDrafts(UserId, isManagedUser, SortBy, Page, PageSize, PageFilter)),
    onInitPostForm: (postId, isDraft, isGift, redirectPath, userId, isManagedUser) =>
      dispatch(actions.initPostFormStart(postId, isDraft, isGift, redirectPath, userId, isManagedUser)),
    onDuplicatePost: (postId, isDraft, copyNumber) => dispatch(actions.duplicatePost(postId, isDraft, copyNumber)),
    onDeletePost: (postId) => dispatch(actions.deletePost(postId)),
    onToggleGiftsDraftsModal: () => dispatch(actions.toggleGiftsDraftsModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Drafts);
